import React, { useState } from 'react';
import api from "../../utils/axiosInstance";
import "@fontsource/oswald";
import Select from 'react-select';
import HeaderBlue from '../../components/HeaderBlue';
import FooterBlue from '../../components/FooterBlue';

const DriverRegister = () => {
    const [formData, setFormData] = useState({
        name: '',
        experience: '',
        route: '',
        job: '',
        trailer: '',
        cdl: '',
        endorsements: '',
        phone: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        password: '',
        confirmPassword: '',
        terms: false
    });

    const [showModal, setShowModal] = useState(false);

    const STATES = [
        { code: 'AL', name: 'Alabama' },
        { code: 'AK', name: 'Alaska' },
        { code: 'AZ', name: 'Arizona' },
        { code: 'AR', name: 'Arkansas' },
        { code: 'CA', name: 'California' },
        { code: 'CO', name: 'Colorado' },
        { code: 'CT', name: 'Connecticut' },
        { code: 'DE', name: 'Delaware' },
        { code: 'FL', name: 'Florida' },
        { code: 'GA', name: 'Georgia' },
        { code: 'HI', name: 'Hawaii' },
        { code: 'ID', name: 'Idaho' },
        { code: 'IL', name: 'Illinois' },
        { code: 'IN', name: 'Indiana' },
        { code: 'IA', name: 'Iowa' },
        { code: 'KS', name: 'Kansas' },
        { code: 'KY', name: 'Kentucky' },
        { code: 'LA', name: 'Louisiana' },
        { code: 'ME', name: 'Maine' },
        { code: 'MD', name: 'Maryland' },
        { code: 'MA', name: 'Massachusetts' },
        { code: 'MI', name: 'Michigan' },
        { code: 'MN', name: 'Minnesota' },
        { code: 'MS', name: 'Mississippi' },
        { code: 'MO', name: 'Missouri' },
        { code: 'MT', name: 'Montana' },
        { code: 'NE', name: 'Nebraska' },
        { code: 'NV', name: 'Nevada' },
        { code: 'NH', name: 'New Hampshire' },
        { code: 'NJ', name: 'New Jersey' },
        { code: 'NM', name: 'New Mexico' },
        { code: 'NY', name: 'New York' },
        { code: 'NC', name: 'North Carolina' },
        { code: 'ND', name: 'North Dakota' },
        { code: 'OH', name: 'Ohio' },
        { code: 'OK', name: 'Oklahoma' },
        { code: 'OR', name: 'Oregon' },
        { code: 'PA', name: 'Pennsylvania' },
        { code: 'RI', name: 'Rhode Island' },
        { code: 'SC', name: 'South Carolina' },
        { code: 'SD', name: 'South Dakota' },
        { code: 'TN', name: 'Tennessee' },
        { code: 'TX', name: 'Texas' },
        { code: 'UT', name: 'Utah' },
        { code: 'VT', name: 'Vermont' },
        { code: 'VA', name: 'Virginia' },
        { code: 'WA', name: 'Washington' },
        { code: 'WV', name: 'West Virginia' },
        { code: 'WI', name: 'Wisconsin' },
        { code: 'WY', name: 'Wyoming' }
    ];

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const newErrors = {};

        // Password checks
        if (formData.password !== formData.confirmPassword) {
            alert('❗ Passwords do not match!');
            return;
        }

        if (formData.password.length < 8) {
            alert('❗ Password must be at least 8 characters long!');
            return;
        }

        // Terms check
        if (!formData.terms) {
            alert('❗ You must agree to the Terms of Service and Privacy Policy');
            return;
        }

        // Phone validation
        if (!/^\(\d{3}\)\s\d{3}-\d{4}$/.test(formData.phone)) {
            newErrors.phone = 'Invalid US phone number format';
        }

        if (Object.keys(newErrors).length > 0) {
            console.warn('Form validation failed:', newErrors);
            alert('Please fix form errors before submitting.');
            return;
        }

        try {
            const response = await api.post('/pendingdrivers', {
                name: formData.name,
                phone: formData.phone,
                password: formData.password,

                // Non-mandatory fields can still be sent if filled
                email: formData.email,
                experience: formData.experience,
                route: formData.route,
                job: formData.job,
                trailer: formData.trailer,
                cdl: formData.cdl,
                endorsements: formData.endorsements,
                address: formData.address,
                city: formData.city,
                state: formData.state,
                zip: formData.zip,
            });

            if (response.status === 201) {
                setShowModal(true);
            } else {
                alert('❌ Unexpected error. Please try again.');
            }
        } catch (err) {
            console.error('❌ Registration failed:', err.response?.data || err.message);
            const serverMessage = err.response?.data?.message || 'Server error occurred. Try again later.';
            alert(`Registration failed: ${serverMessage}`);
        }
    };


    const trailerOptions = [
        { value: "Van", label: "Van" },
        { value: "Flatbed", label: "Flatbed" },
        { value: "Reefer", label: "Reefer" },
        { value: "Tanker", label: "Tanker" },
        { value: "Other", label: "Others" },
    ];

    const routeOptions = [
        { value: "OTR", label: "Over the Road" },
        { value: "Regional", label: "Regional" },
        { value: "Local", label: "Local" },
        { value: "All", label: "All Routes" },
    ];

    const endorsementOptions = [
        { value: "Hazmat", label: "Hazmat" },
        { value: "Double", label: "Doubles/Triples" },
        { value: "Tank", label: "Tank" },
        { value: "Hazardous", label: "Hazardous Tanker" },
        { value: "Passenger", label: "Passenger" },
        { value: "None", label: "None of these" },
    ];

    function formatPhoneNumber(value) {
        if (!value) return value;
        const phoneNumber = value.replace(/[^\d]/g, '');
        const phoneLength = phoneNumber.length;

        if (phoneLength < 4) return phoneNumber;
        if (phoneLength < 7) {
            return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
        }
        return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
    }

    const redirectToHome = () => {
        window.location.href = '/';
    };

    const customStyle = {
        control: (provided, state) => ({
            ...provided,
            backgroundColor: '#ffffff',
            borderColor: state.isFocused ? '#9ca3af' : '#d1d5db',
            paddingLeft: '2rem',
            minHeight: '3rem', // py-4 equivalent
            boxShadow: state.isFocused ? '0 0 0 2px rgba(20, 74, 250, 0.5)' : 'none',
            borderRadius: '0.375rem', // rounded-md
            color: '#000000',
        }),
        multiValue: (provided) => ({
            ...provided,
            backgroundColor: '#e5e7eb', // Tailwind: bg-gray-200
        }),
        multiValueLabel: (provided) => ({
            ...provided,
            color: '#000000', // black text inside selected tags
        }),
        input: (provided) => ({
            ...provided,
            color: '#000000', // input text color
        }),
        placeholder: (provided) => ({
            ...provided,
            color: '#6b7280', // Tailwind: text-gray-500
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isFocused ? '#e5e7eb' : '#ffffff', // gray on hover, white otherwise
            color: '#000000',
            cursor: 'pointer',
        }),
        menu: (provided) => ({
            ...provided,
            backgroundColor: '#ffffff', // white dropdown
            zIndex: 50,
        }),
    };

    return (
        <div className="flex flex-col min-h-screen bg-gray-100">
            <HeaderBlue />

            {/* Hero Section */}

            <section className="w-full py-60 relative"
                style={{
                    backgroundImage: "url('./assets/driverregister2.webp')",
                    backgroundSize: 'cover',
                    backgroundPosition: 'center'
                }}>
                <div className="absolute inset-0 bg-gradient-to-r from-black/80 to-white/10 z-0"></div>
                <div className="md:px-40 relative z-10">
                    <h2 className="text-white text-6xl font-oswald drop-shadow-lg pb-5">DRIVER REGISTRATION</h2>
                    <p className="text-white text-xl font-semibold font-oswald mt-2">
                        Create a driver account, get hired & start earning.

                    </p>
                </div>
            </section>

            {/* Main Content */}
            <div className="max-w-6xl mx-auto px-5 mt-10 flex-grow">
                <div className="flex flex-col lg:flex-row gap-10 bg-white rounded-lg overflow-hidden shadow-xl">
                    <div className="flex-1 p-10">
                        <form id="driverRegistrationForm" className="space-y-6" onSubmit={handleSubmit}>

                            {/* 1st row: Name & Experience */}
                            <div className="flex flex-col md:flex-row gap-5">
                                <div className="flex-1">
                                    <label htmlFor="name" className="block mb-2 font-medium text-gray-900">Name *</label>
                                    <div className="relative">
                                        <i className="fas fa-user absolute left-4 top-1/2 -translate-y-1/2 text-gray-500"></i>
                                        <input
                                            type="text"
                                            id="name"
                                            name="name"
                                            placeholder="Enter name"
                                            required
                                            className="w-full pl-12 pr-4 py-4 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-400 focus:border-transparent transition"
                                            value={formData.name}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                                <div className="flex-1">
                                    <label htmlFor="experience" className="block mb-2 font-medium text-gray-900">Experience *</label>
                                    <div className="relative">
                                        <i className="fas fa-calendar absolute left-4 top-1/2 -translate-y-1/2 text-gray-500"></i>
                                        <select
                                            id="experience"
                                            name="experience"
                                            required
                                            className="w-full pl-12 pr-4 py-4 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-400 focus:border-transparent transition"
                                            value={formData.experience}
                                            onChange={handleChange}
                                        >
                                            <option value="">Select experience</option>
                                            <option value="none">None</option>
                                            <option value="6 months">6 months</option>
                                            <option value="1 year">1 Year</option>
                                            <option value="2 year">2 Year</option>
                                            <option value="3+">3+ Years</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            {/* 2nd row: Job Type & CDL */}
                            <div className="flex flex-col md:flex-row gap-5">
                                <div className="flex-1">
                                    <label htmlFor="job" className="block mb-2 font-medium text-gray-900">Job Type *</label>
                                    <div className="relative">
                                        <i className="fas fa-suitcase absolute left-4 top-1/2 -translate-y-1/2 text-gray-500"></i>
                                        <select
                                            id="job"
                                            name="job"
                                            required
                                            className="w-full pl-12 pr-4 py-4 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-400 focus:border-transparent transition"
                                            value={formData.job}
                                            onChange={handleChange}
                                        >
                                            <option value="">Select Job Type</option>
                                            <option value="Company Driver">Company Driver</option>
                                            <option value="Owner Operator">Owner Operator</option>
                                            <option value="Training">Driver Training</option>
                                            <option value="Lease">Lease Purchase</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="flex-1">
                                    <label htmlFor="cdl" className="block mb-2 font-medium text-gray-900">Active CDL Type *</label>
                                    <div className="relative">
                                        <i className="fas fa-drivers-license absolute left-4 top-1/2 -translate-y-1/2 text-gray-500"></i>
                                        <select
                                            id="cdl"
                                            name="cdl"
                                            required
                                            className="w-full pl-12 pr-4 py-4 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-400 focus:border-transparent transition"
                                            value={formData.cdl}
                                            onChange={handleChange}
                                        >
                                            <option value="">Select CDL Type</option>
                                            <option value="Class A">Class A</option>
                                            <option value="Class B">Class B</option>
                                            <option value="Class C">Class C</option>
                                            <option value="No CDL">I don't have a CDL</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            {/* 3rd row: Route Type */}
                            <div>
                                <label htmlFor="route" className="block mb-2 font-medium text-gray-900">Route Type *</label>
                                <div className="relative">
                                    <i className="fas fa-truck absolute left-4 top-1/2 -translate-y-1/2 text-gray-500"></i>
                                    <div className="pl-12">
                                        <Select
                                            isMulti
                                            name="route"
                                            required
                                            placeholder="Select multiple if required"
                                            options={routeOptions}
                                            styles={customStyle}
                                            value={routeOptions.filter(opt => formData.route.includes(opt.value))}
                                            onChange={(selected) =>
                                                setFormData({ ...formData, route: selected.map((s) => s.value) })
                                            }
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* 4th row: Trailer Type */}
                            <div>
                                <label htmlFor="trailer" className="block mb-2 font-medium text-gray-900">Trailer Type *</label>
                                <div className="relative">
                                    <i className="fas fa-truck absolute left-4 top-1/2 -translate-y-1/2 text-gray-500"></i>
                                    <div className="pl-12">
                                        <Select
                                            isMulti
                                            name="trailer"
                                            required
                                            placeholder="Select multiple if required"
                                            options={trailerOptions}
                                            styles={customStyle}
                                            value={trailerOptions.filter(opt => formData.trailer.includes(opt.value))}
                                            onChange={(selected) =>
                                                setFormData({ ...formData, trailer: selected.map((s) => s.value) })
                                            }
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* 5th row: Endorsements */}
                            <div>
                                <label htmlFor="endorsements" className="block mb-2 font-medium text-gray-900">Endorsements Obtained *</label>
                                <div className="relative">
                                    <i className="fas fa-drivers-license absolute left-4 top-1/2 -translate-y-1/2 text-gray-500"></i>
                                    <div className="pl-12">
                                        <Select
                                            isMulti
                                            name="endorsements"
                                            placeholder="Select multiple if required"
                                            options={endorsementOptions}
                                            required
                                            styles={customStyle}
                                            value={endorsementOptions.filter(opt => formData.endorsements.includes(opt.value))}
                                            onChange={(selected) =>
                                                setFormData({ ...formData, endorsements: selected.map((s) => s.value) })
                                            }
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Phone and Address/Email etc as before */}
                            <div className="flex flex-col md:flex-row gap-5">
                                <div className="flex-1">
                                    <label htmlFor="phone" className="block mb-2 font-medium text-gray-900">Phone Number *</label>
                                    <div className="relative">
                                        <i className="fas fa-phone absolute left-4 top-1/2 -translate-y-1/2 text-gray-500"></i>
                                        <input
                                            type="tel"
                                            id="phone"
                                            name="phone"
                                            placeholder="(123) 456-7890"
                                            required
                                            maxLength={14}
                                            className="w-full pl-12 pr-4 py-4 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-400 focus:border-transparent transition"
                                            value={formData.phone}
                                            onChange={(e) => {
                                                const input = e.target.value.replace(/\D/g, '').slice(0, 10);
                                                const formatted = formatPhoneNumber(input);
                                                setFormData({ ...formData, phone: formatted });
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div>
                                <label htmlFor="address" className="block mb-2 font-medium text-gray-900">Address *</label>
                                <div className="relative">
                                    <i className="fas fa-map-marker-alt absolute left-4 top-1/2 -translate-y-1/2 text-gray-500"></i>
                                    <input
                                        type="text"
                                        id="address"
                                        name="address"
                                        required
                                        placeholder="Street address"
                                        className="w-full pl-12 pr-4 py-4 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-400 focus:border-transparent transition"
                                        value={formData.address}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>

                            <div className="flex flex-col md:flex-row gap-5">
                                <div className="flex-1">
                                    <label htmlFor="city" className="block mb-2 font-medium text-gray-900">City *</label>
                                    <div className="relative">
                                        <i className="fas fa-city absolute left-4 top-1/2 -translate-y-1/2 text-gray-500"></i>
                                        <input
                                            type="text"
                                            id="city"
                                            name="city"
                                            required
                                            placeholder="City"
                                            className="w-full pl-12 pr-4 py-4 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-400 focus:border-transparent transition"
                                            value={formData.city}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                                <div className="flex-1">
                                    <label htmlFor="state" className="block mb-2 font-medium text-gray-900">State *</label>
                                    <div className="relative">
                                        <i className="fas fa-flag-usa absolute left-4 top-1/2 -translate-y-1/2 text-gray-500"></i>
                                        <select
                                            id="state"
                                            name="state"
                                            required
                                            className="w-full pl-12 pr-4 py-4 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-400 focus:border-transparent transition"
                                            value={formData.state}
                                            onChange={handleChange}
                                        >
                                            <option value="">Select state</option>
                                            {STATES.map(state => (
                                                <option key={state.code} value={state.code}>
                                                    {state.name} ({state.code})
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <div className="flex-1">
                                    <label htmlFor="zip" className="block mb-2 font-medium text-gray-900">ZIP Code *</label>
                                    <div className="relative">
                                        <i className="fas fa-mail-bulk absolute left-4 top-1/2 -translate-y-1/2 text-gray-500"></i>
                                        <input
                                            type="text"
                                            id="zip"
                                            name="zip"
                                            required
                                            placeholder="ZIP code"
                                            className="w-full pl-12 pr-4 py-4 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-400 focus:border-transparent transition"
                                            value={formData.zip}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="flex-1">
                                <label htmlFor="email" className="block mb-2 font-medium text-gray-900">Email *</label>
                                <div className="relative">
                                    <i className="fas fa-envelope absolute left-4 top-1/2 -translate-y-1/2 text-gray-500"></i>
                                    <input
                                        type="email"
                                        id="email"
                                        name="email"
                                        placeholder="Enter email"
                                        required
                                        className="w-full pl-12 pr-4 py-4 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-400"
                                        value={formData.email}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>

                            <div className="flex flex-col md:flex-row gap-5">
                                <div className="flex-1">
                                    <label htmlFor="password" className="block mb-2 font-medium text-gray-900">Password *</label>
                                    <div className="relative">
                                        <i className="fas fa-lock absolute left-4 top-1/2 -translate-y-1/2 text-gray-500"></i>
                                        <input
                                            type="password"
                                            id="password"
                                            name="password"
                                            placeholder="Create password"
                                            required
                                            className="w-full pl-12 pr-4 py-4 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-400 focus:border-transparent transition"
                                            value={formData.password}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                                <div className="flex-1">
                                    <label htmlFor="confirmPassword" className="block mb-2 font-medium text-gray-900">Confirm Password *</label>
                                    <div className="relative">
                                        <i className="fas fa-lock absolute left-4 top-1/2 -translate-y-1/2 text-gray-500"></i>
                                        <input
                                            type="password"
                                            id="confirmPassword"
                                            name="confirmPassword"
                                            placeholder="Confirm password"
                                            required
                                            className="w-full pl-12 pr-4 py-4 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-400 focus:border-transparent transition"
                                            value={formData.confirmPassword}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="flex items-center gap-3 my-6">
                                <input
                                    type="checkbox"
                                    id="terms"
                                    name="terms"
                                    required
                                    className="w-auto"
                                    checked={formData.terms}
                                    onChange={handleChange}
                                />
                                <label htmlFor="terms" className="text-gray-700">
                                    I agree to the <a href="/terms-of-use" className="text-primary hover:underline">Terms of Service</a> and
                                    <a href="/privacy-policy" className="text-primary hover:underline"> Privacy Policy</a>
                                </label>
                            </div>

                            <button
                                type="submit"
                                className="w-full bg-primary text-white py-4 px-8 rounded-md font-semibold hover:bg-blue-500"
                            >
                                Create Driver Account
                            </button>

                        </form>

                    </div>

                    <div
                        className="flex-1 relative min-h-[600px] p-10 text-white flex flex-col justify-start"
                        style={{
                            backgroundImage: "url('./assets/driver-transport.webp')",
                            backgroundSize: 'cover',
                            backgroundPosition: 'center'
                        }}
                    >
                        <div className="absolute inset-0 bg-black/25 z-10"></div>
                        <div className="relative z-20">
                            <h3 className="text-3xl font-bold mb-5">Why Register as a Driver?</h3>
                            <p className="mb-8">Join thousands of drivers finding great job opportunities through our platform.</p>
                            <ul className="space-y-5">
                                <li className="flex gap-4">
                                    <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center">
                                        <i className="fas fa-briefcase text-xl text-white"></i>
                                    </div>
                                    <div>
                                        <strong className="font-semibold">Access Top Jobs</strong>
                                        <p>Explore job listings from leading trucking companies</p>
                                    </div>
                                </li>
                                <li className="flex gap-4">
                                    <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center">
                                        <i className="fas fa-map-marked-alt text-xl text-white"></i>
                                    </div>
                                    <div>
                                        <strong className="font-semibold">Find Local Opportunities</strong>
                                        <p>Search for jobs in your area or preferred routes</p>
                                    </div>
                                </li>
                                <li className="flex gap-4">
                                    <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center">
                                        <i className="fas fa-dollar-sign text-xl text-white"></i>
                                    </div>
                                    <div>
                                        <strong className="font-semibold">Compare Salaries</strong>
                                        <p>View salary details to find the best-paying jobs</p>
                                    </div>
                                </li>
                                <li className="flex gap-4">
                                    <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center">
                                        <i className="fas fa-user-check text-xl text-white"></i>
                                    </div>
                                    <div>
                                        <strong className="font-semibold">Profile Visibility</strong>
                                        <p>Get noticed by carriers with a verified driver profile</p>
                                    </div>
                                </li>
                            </ul>
                            <div className="bg-black/10 p-5 rounded-lg mt-5">
                                <i className="fas fa-lightbulb mr-2"></i>
                                Pro Tip: Keep your profile updated with your latest experience and certifications to get noticed by top carriers faster.
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            {/* Success Modal */}
            {showModal && (
                <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
                    <div className="bg-white max-w-2xl mx-auto rounded-xl shadow-xl p-10 text-center">
                        <div className="text-green-600 text-6xl mb-6">
                            <i className="fas fa-check-circle"></i>
                        </div>
                        <h2 className="text-3xl font-bold text-black mb-4">
                            Welcome to <span className="text-blue-700">Fleety</span> Portal!
                        </h2>
                        <p className="text-gray-700 mb-6">
                            "Driver registered successfully! Please check your email for confirmation."
                        </p>
                        <button
                            onClick={redirectToHome}
                            className="px-8 py-3 bg-blue-700 hover:bg-blue-800 text-white rounded-lg shadow font-semibold"
                        >
                            Go to Home
                        </button>
                    </div>
                </div>
            )}
            <FooterBlue />
        </div >
    );
};

export default DriverRegister;